import React, { useEffect, useState } from 'react';
import { makeStyles, Theme, createStyles, Container, Grid, CardMedia, Typography } from '@material-ui/core';
import ReactPlayer from 'react-player';
import VideoOneLayout from './VideosLayout/VideoOneLayout';
import VideoTwoLayout from './VideosLayout/VideoTwoLayout';
import VideoThreeLayout from './VideosLayout/VideoThreeLayout';
import VideoFourLayout from './VideosLayout/VideoFourLayout';
import VideosLayout from './VideosLayout';
import ImagesLayout from './ImagesLayout';
import FilesLayout from './FilesLayout';
import SeparteImage from './SeparteImage';

// import { stateToHTML } from "draft-js-export-html";
// import { Editor, EditorState, convertToRaw, convertFromRaw } from "draft-js";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionRoot: {
      background: 'white',
      // minHeight: "90vh",
      marginTop: '8%',
      marginBottom: '8%',
      //   padding: "0 4.948% 109px 4.948%",
      paddingLeft: '6rem',
      paddingRight: '6rem',
      [theme.breakpoints.down('xs')]: {
        paddingLeft: 32,
        paddingRight: 32,
      },
    },
    sectionRoot2: {
      background: 'white',
      minHeight: '55vh',
      // marginTop: "8%",
      marginBottom: '8%',
      //   padding: "0 4.948% 109px 4.948%",
      // paddingLeft: "6rem",
      // paddingRight: "6rem",
      // paddingTop: "56.25%",
      // backgroundSize: "100%",
      // backgroundPosition: "50% 50%",
    },
    categoryText: {
      // fontFamily:"Black Han Sans"
      fontFamily: 'Noto Sans Kr',
      fontSize: 48,
      color: 'black',
      fontWeight: 900,
      letterSpacing: -4,
      paddingBottom: 16,
    },
    subCategory: {
      fontFamily: 'Noto Sans Kr',
      fontSize: 40,
      color: 'black',
      fontWeight: 500,
      //   paddingLeft:6
      letterSpacing: -1,
    },
    winnerDiv: {
      // paddingTop: "4rem"
    },
    winnerCategory: {
      fontSize: 20,
      fontWeight: 900,
      paddingRight: 32,
      //   color: "#7a5f50",
      color: 'black',
      fontFamily: 'Noto Sans Kr',
      paddingBottom: 8,
    },
    winnerName: {
      fontSize: 20,
      fontWeight: 400,
      color: 'black',
      fontFamily: 'Noto Sans Kr',
    },
    winnerTopDiv: {
      //   display: "flex",
      paddingBottom: 32,
    },
  }),
);
interface ConcertMaterialProps {
  // history: History;
  rowData: any;
}

function CitizenMaterial({ rowData }: ConcertMaterialProps) {
  // const { history } = props;

  const [urlArray, setUrlArray] = useState<any>(null);
  const [imgArray, setImgArray] = useState<any>(null);
  const [fileArray, setFileArray] = useState<any>(null);

  useEffect(() => {
    setUrlArray(rowData.citizen_joy_videos);
    setImgArray(rowData.citizen_joy_images);
    setFileArray(rowData.citizen_joy_files);

    return () => {
      setUrlArray(null);
      setImgArray(null);
      setFileArray(null);
    };
  }, [rowData]);
  // let html = stateToHTML(contentState.getCurrentContent());

  const classes = useStyles();

  return (
    <Container maxWidth={false} disableGutters={true} className={classes.sectionRoot}>
      <Container maxWidth={'xl'} disableGutters={true}>
        {urlArray ? <VideosLayout urlArray={urlArray} /> : <div></div>}
        {/* {imgArray && imgArray.length > 0 ? (
          <ImagesLayout imgArr={imgArray} />
        ) : (
          <div></div>
        )} */}
        {fileArray ? <FilesLayout fileArray={fileArray} /> : <div></div>}
        <SeparteImage id={rowData.id} />
      </Container>
    </Container>
  );
}

export default CitizenMaterial;
